<template>
  <div @contextmenu.prevent>
    <div id="AntiPrint" class="hidden">
      <h1 class="text-black">
        Nope! - Printing, Recording, Screenshotting or Sharing Simulations Is Not Allowed<br /><br />Your Access Will Be Terminated If The
        TOS Is Broken<br /><br />Contact Intellectual Point For More Information<br /><br />
      </h1>
      <h1 class="text-black">{{ activeUserInfo.id }}</h1>
      <h1 class="text-black">{{ activeUserInfo.first_name }} {{ activeUserInfo.last_name }}</h1>
      <h1 class="text-black">{{ activeUserInfo.email }}</h1>
    </div>
    <div v-if="labData" ref="cursor" class="vx-row simulation-page" id="LegacySimulationRenderer">
      <div class="vx-col w-full">
        <vx-card class="mb-3">
          <div class="flex justify-between items-center align-middle">
            <div class="flex items-center align-middle">
              <img
                :src="labData.thumbnail"
                v-if="labData.thumbnail"
                width="40"
                height="40"
                class="rounded shadow-md cursor-pointer block mr-3"
                draggable="false"
                alt=""
              />
              <vs-input v-if="enableEditMode" v-model="labData.name" class="ml-1" style="min-width: 14vw"></vs-input>
              <h2 v-else class="font-bold ml-2">{{ labData.name }}</h2>
            </div>
            <div class="flex items-center align-middle gap-3">
              <vs-button
                v-if="labData.explanation_video_url"
                type="gradient"
                color="success"
                icon-pack="feather"
                icon="icon-film"
                @click="toggleExplanationVideo"
              >
                {{ showExplanationVideo === false ? 'Watch the Lab Video' : 'Hide the Lab Video' }}
              </vs-button>
              <vs-button
                v-if="iframeSupported"
                type="gradient"
                color="warning"
                icon-pack="feather"
                icon="icon-refresh-cw"
                @click="reloadLab"
                >Reload
              </vs-button>
              <vs-button type="gradient" color="primary" icon-pack="feather" icon="icon-maximize" @click="fullscreenLab"
                >Fullscreen
              </vs-button>
              <vs-button type="gradient" color="danger" icon-pack="feather" icon="icon-arrow-left" @click="exitLab">End Lab </vs-button>
            </div>
          </div>
        </vx-card>
        <div class="vx-card mb-3">
          <div v-if="labActive" class="flex justify-between items-center align-middle">
            <div v-if="iframeSupported" class="lab-frame-full">
              <fullscreen v-model="labFullScreen" class="lab-frame-full">
                <iframe class="lab-frame" :src="labInstance.accessUrl" :key="iframeKey" sandbox="allow-scripts allow-same-origin"></iframe>
              </fullscreen>
            </div>
            <div class="p-6" v-else>
              <div class="flex items-center gap-2 mb-4">
                <feather-icon icon="InfoIcon" svgClasses="h-8 w-8" />
                <h2 class="font-light">
                  {{ openFailed ? 'Press The Button Below To Open The Lab' : 'Lab Opened In Popup Window' }}
                </h2>
              </div>
              <vs-button
                type="gradient"
                :color="openFailed ? 'success' : 'primary'"
                icon="icon-external-link"
                icon-pack="feather"
                @click="openWindowOrTab(labInstance.accessUrl)"
                >{{ openFailed ? 'Open Lab' : 'Reopen Lab' }}
              </vs-button>
            </div>
          </div>
          <div v-else>
            <div class="loading-block flex flex-col justify-center align-middle">
              <div class="lab-loader">
                <span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
                <div class="base">
                  <span></span>
                  <div class="face"></div>
                </div>
              </div>
              <div class="longfazers">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
              <div class="loading-text">
                <h1 class="font-bold text-center mb-2">{{ loadingText }}</h1>
                <h5 class="font-light text-center">Launching Your Lab Can Take Upto 30 Seconds</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <movable-popup
        ref="videoPlayer"
        refVal="videoPlayerRef"
        title="Playing Video - Click Here to Drag Video Player"
        :z-index="53000"
        :active="showExplanationVideo"
        v-on:close="showExplanationVideo = false"
        padding="0"
      >
        <template v-slot:content>
          <div style="position: relative; padding-top: 56.25%">
            <iframe
              :src="labData.explanation_video_url"
              style="border: none; position: absolute; top: 0; left: 0; height: 100%; width: 100%"
              allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
              allowfullscreen="true"
            ></iframe>
          </div>
        </template>
      </movable-popup>

      <!--- USER DISPLAY INFO --->
      <div class="vx-col">
        <p class="mt-4" style="opacity: 85%">{{ activeUserInfo.first_name }} {{ activeUserInfo.last_name }} - {{ activeUserInfo.email }}</p>
      </div>
    </div>
    <div class="simple-spinner" v-else>
      <span></span>
    </div>
  </div>
</template>
<script>
import 'quill/dist/quill.snow.css'
import { quillEditor } from 'vue-quill-editor'
import MovablePopup from '../../../../components/popup/MovablePopup'
import RadialProgressBar from 'vue-radial-progress'
import LottieAnimation from '../../../../components/lottie/LottieAnimation'
import axios from 'axios'
import VueResizable from 'vue-resizable'

export default {
  data () {
    return {
      componentFile: null,
      labData: null,
      labToken: null,
      labComplete: false,

      labInstance: null,
      labActive: false,
      labFullScreen: false,

      labErrorCount: 0,

      showGettingThereDialog: false,
      showSimulationFullCorrect: false,

      renderKey: 0,

      isUserProctor: false,
      enableEditMode: false,
      editDescriptionCounter: 0,

      labPaused: false,
      labAntiSkid: true,

      showExplanationVideo: false,

      loadingText: '',
      loadingOptions: [
        'Preparing For Liftoff',
        'To Infinity And Beyond!',
        'Preparing For Hyperdrive',
        'Preparing To Blast Off To Lab-land',
        'Engaging Lab Launch Thrusters',
        'Shields Up For Lab Launch',
        'Launching Lab Into Cyberspace',
        'Preparing Lab For Warp Speed',
        'Strapping In for Lab Launch!'
      ],

      consoleLogs: [],

      iframeKey: 0,
      iframeSupported: true,
      openFailed: false
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  },
  methods: {
    async checkTPC () {
      return new Promise((resolve, reject) => {
        const frame = document.createElement('iframe')
        frame.id = '3pc'
        frame.src = 'https://chamithrepo.github.io/create-third-party-cookie/' // Add your hosted domain url here
        frame.style.display = 'none'
        frame.style.position = 'fixed'
        document.body.appendChild(frame)

        window.addEventListener(
          'message',
          (event) => {
            if (event.data === '3pcSupported' || event.data === '3pcUnsupported') {
              const isSupported = event.data === '3pcSupported'
              document.body.removeChild(frame)
              window.removeEventListener('message', (event) => {})
              resolve(isSupported)
            }
          },
          false,
        )
      })
    },
    antiLeaveWindow () {
      this.labPaused = true
    },
    confirmExitLab () {
      this.$vs.loading()
      const connectToken = localStorage.getItem('accessToken')
      axios
        .post(`${process.env.VUE_APP_ROOT_LABS_API}/tenants/connect/end`, {
          token: connectToken
        })
        .then((response) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Lab Ended Successfully',
            text: 'Your lab has been successfully ended',
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-check-circle'
          })
          this.$router.push('/labs/select')
        })
        .catch((error) => {
          this.$vs.loading.close()
          if (error.response.data.type === 'LAB_PENDING_PROVISION') {
            this.$vs.notify({
              title: 'Couldn\'t End Lab',
              text: 'Please wait until the lab has been created before ending it',
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-x-circle'
            })
          }
          if (error.response.data.type === 'LAB_UNSAVE') {
            this.getLabData()
          }
          if (error.response.data.type === 'NO_LAB_RUNNING') {
            this.$router.push('/labs/select')
          }
        })
    },
    exitLab () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'End Lab',
        text: 'Please confirm you want to end the lab. You will loose all of your progress.',
        accept: this.confirmExitLab,
        acceptText: 'End Lab'
      })
    },
    getLabData () {
      this.$http
        .get(`app/labs/${this.$route.params.labId}/starter`)
        .then((response) => {
          if (response.status === 200) {
            this.$vs.loading.close()
            this.labData = response.data.data.lab
            this.labToken = response.data.data.token
            this.initLab()
          }
        })
        .catch(() => {
          this.$vs.notify({
            title: 'Error While Loading Lab',
            text: 'Please ensure you have the courses selected for the lab you are trying to access',
            color: 'danger',
            position: 'bottom-right'
          })
          this.$router.push('/labs/select')
        })
    },
    errorLab (title, message, exit) {
      this.$vs.dialog({
        color: 'danger',
        title,
        text: message
      })

      if (exit) {
        this.$router.push('/labs/select')
      }
    },
    fullscreenLab () {
      this.labFullScreen = true
      return this.$vs.notify({
        title: 'Lab Fullscreen Mode Enabled',
        text: 'Press ESC To Exit',
        color: 'primary',
        iconPack: 'feather',
        position: 'bottom-right',
        icon: 'icon-check-circle'
      })
    },
    initLab () {
      if (this.labErrorCount > 3) {
        return this.errorLab('Lab Was Not Able To Launch', 'Please contact support if this keeps happening', true)
      }
      axios
        .post(`${process.env.VUE_APP_ROOT_LABS_API}/tenants/connect/start`, {
          token: this.labToken
        })
        .then((response) => {
          this.processLab(response.data)
          console.log(response)
        })
        .catch((error) => {
          if (error.response.data.type === 'USER_HAS_LAB_RUNNING') {
            return this.resumeLab()
          }
          if (error.response.data.type === 'LAB_EXPIRED') {
            return this.errorLab('Your Lab Has Expired', 'Please try starting a new lab.', true)
          }
          if (error.response.data.type === 'LAB_GET_ERR') {
            return this.errorLab('Lab Was Not Able To Launch', 'Please contact support if this keeps happening.', true)
          }
          if (error.response.data.type === 'USER_GENERATING_LAB') {
            return this.errorLab(
              'You Are Already Starting Another Lab',
              'Please end any other running lab before starting a new one.',
              true,
            )
          }
          if (error.response.data.type === 'TOO_MANY_USERS') {
            return this.errorLab('Labs Is At Full Capacity', 'Please wait upto 15 minutes before trying again.', true)
          }
          this.labErrorCount++
        })
    },
    resumeLab () {
      const connectToken = localStorage.getItem('accessToken')
      axios
        .post(`${process.env.VUE_APP_ROOT_LABS_API}/tenants/connect/get`, {
          token: connectToken
        })
        .then((response) => {
          this.processLab(response.data.instance)
          console.log(response)
        })
        .catch((error) => {
          if (error.response.data.type === 'LAB_GET_ERR') {
            return this.errorLab('Something Went Wrong', 'Please try again, contact support if this keeps happening', true)
          }
          if (error.response.data.type === 'LAB_NOT_UPDATED') {
            return setTimeout(() => {
              this.getLabData()
            }, 10000)
          }
          this.labErrorCount++
          this.getLabData()
        })
    },
    processLab (instance) {
      this.labInstance = instance

      if (this.labInstance.activityId !== this.labData.labs_activity_id) {
        return this.errorLab('You Are Currently Running Another Lab', 'Please end your other lab first before starting another one', true)
      }

      if (!this.iframeSupported) {
        this.openWindowOrTab(this.labInstance.accessUrl)
      }

      this.labActive = true
    },
    leaveLab () {
      // Write Leave Labs Code
    },
    async playLab () {
      let TPC = true
      try {
        TPC = await this.checkTPC()
      } catch (e) {
        console.log('TPC Check Error')
      }
      this.iframeSupported = TPC
      this.getLabData()
    },
    simulationUpdateOptions (data) {
      this.simulationOptions = data
    },
    toggleExplanationVideo () {
      if (this.showExplanationVideo === false) {
        this.showExplanationVideo = true
      } else {
        this.$refs.videoPlayer.close()
      }
    },
    openWindowOrTab (url) {
      const features =
        'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=1200,height=800'
      let popupWindow = null

      try {
        popupWindow = window.open(url, '_blank', features)
        popupWindow.focus()
        this.openFailed = false
      } catch (error) {
        console.log('Error opening popup window: ', error)
        this.openFailed = true
      }
    },
    reloadLab () {
      this.iframeKey++
    }
  },
  mounted () {
    this.simulationTabError = new Audio('https://sims-cdn.intellectualpoint.com/sounds/effect/Notification.mp3')
    this.simulationFullCorrectSound = new Audio('https://sims-cdn.intellectualpoint.com/sounds/effect/Success.mp3')
    this.simulationGettingThereSound = new Audio('https://sims-cdn.intellectualpoint.com/sounds/effect/Error_Notification.mp3')

    window.simulationGettingThereSound = this.simulationGettingThereSound
    window.simulationFullCorrectSound = this.simulationFullCorrectSound
    window.simulationTabError = this.simulationTabError

    this.wasSidebarOpen = this.$store.state.reduceButton
    this.$store.commit('TOGGLE_REDUCE_BUTTON', true)

    const loadingIndex = Math.floor(Math.random() * this.loadingOptions.length)
    this.loadingText = this.loadingOptions[loadingIndex]

    this.playLab()

    window.addEventListener('blur', this.antiLeaveWindow)

    if (this.$acl.check('proctor')) {
      this.labAntiSkid = false
      this.isUserProctor = true
      
    }
  },
  beforeDestroy () {
    this.leaveLab()
    this.labData = null
    window.removeEventListener('blur', this.antiLeaveWindow)
    if (!this.wasSidebarOpen) this.$store.commit('TOGGLE_REDUCE_BUTTON', false)
  },
  watch: {
    enableEditMode () {
      this.getSimulationData(this.labData.id)
    }
  },
  components: {
    quillEditor,
    MovablePopup,
    RadialProgressBar,
    LottieAnimation,
    VueResizable
  }
}
</script>

<style lang="scss" scoped>
.lab-frame-full {
  width: 100%;
  height: 100vh;
}

.lab-frame {
  border: none;
  border-radius: 5px;
  width: 100%;
  height: 100%;
}

.loading-block {
  min-height: 60vh;
  position: relative;
  overflow: hidden;
}

.loading-text {
  margin-top: 100px;
}

.lab-loader {
  position: absolute;
  top: 40%;
  margin-left: -50px;
  left: 50%;
  animation: speeder 0.4s linear infinite;
}

.lab-loader > span {
  height: 5px;
  width: 35px;
  background: #fff;
  position: absolute;
  top: -19px;
  left: 60px;
  border-radius: 2px 10px 1px 0;
}

.base span {
  position: absolute;
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-right: 100px solid #fff;
  border-bottom: 6px solid transparent;
}

.base span:before {
  content: '';
  height: 22px;
  width: 22px;
  border-radius: 50%;
  background: #fff;
  position: absolute;
  right: -110px;
  top: -16px;
}

.base span:after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-top: 0 solid transparent;
  border-right: 55px solid #fff;
  border-bottom: 16px solid transparent;
  top: -16px;
  right: -98px;
}

.face {
  position: absolute;
  height: 12px;
  width: 20px;
  background: #fff;
  border-radius: 20px 20px 0 0;
  transform: rotate(-40deg);
  right: -125px;
  top: -15px;
}

.face:after {
  content: '';
  height: 12px;
  width: 12px;
  background: #fff;
  right: 4px;
  top: 7px;
  position: absolute;
  transform: rotate(40deg);
  transform-origin: 50% 50%;
  border-radius: 0 0 0 2px;
}

.lab-loader > span > span:nth-child(1),
.lab-loader > span > span:nth-child(2),
.lab-loader > span > span:nth-child(3),
.lab-loader > span > span:nth-child(4) {
  width: 30px;
  height: 1px;
  background: #fff;
  position: absolute;
  animation: fazer1 0.2s linear infinite;
}

.lab-loader > span > span:nth-child(2) {
  top: 3px;
  animation: fazer2 0.4s linear infinite;
}

.lab-loader > span > span:nth-child(3) {
  top: 1px;
  animation: fazer3 0.4s linear infinite;
  animation-delay: -1s;
}

.lab-loader > span > span:nth-child(4) {
  top: 4px;
  animation: fazer4 1s linear infinite;
  animation-delay: -1s;
}

@keyframes fazer1 {
  0% {
    left: 0;
  }
  100% {
    left: -80px;
    opacity: 0;
  }
}

@keyframes fazer2 {
  0% {
    left: 0;
  }
  100% {
    left: -100px;
    opacity: 0;
  }
}

@keyframes fazer3 {
  0% {
    left: 0;
  }
  100% {
    left: -50px;
    opacity: 0;
  }
}

@keyframes fazer4 {
  0% {
    left: 0;
  }
  100% {
    left: -150px;
    opacity: 0;
  }
}

@keyframes speeder {
  0% {
    transform: translate(2px, 1px) rotate(0deg);
  }
  10% {
    transform: translate(-1px, -3px) rotate(-1deg);
  }
  20% {
    transform: translate(-2px, 0px) rotate(1deg);
  }
  30% {
    transform: translate(1px, 2px) rotate(0deg);
  }
  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }
  50% {
    transform: translate(-1px, 3px) rotate(-1deg);
  }
  60% {
    transform: translate(-1px, 1px) rotate(0deg);
  }
  70% {
    transform: translate(3px, 1px) rotate(-1deg);
  }
  80% {
    transform: translate(-2px, -1px) rotate(1deg);
  }
  90% {
    transform: translate(2px, 1px) rotate(0deg);
  }
  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}

.longfazers {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.longfazers span {
  position: absolute;
  height: 2px;
  width: 20%;
  background: #fff;
}

.longfazers span:nth-child(1) {
  top: 20%;
  animation: lf 0.6s linear infinite;
  animation-delay: -5s;
}

.longfazers span:nth-child(2) {
  top: 40%;
  animation: lf2 0.8s linear infinite;
  animation-delay: -1s;
}

.longfazers span:nth-child(3) {
  top: 60%;
  animation: lf3 0.6s linear infinite;
}

.longfazers span:nth-child(4) {
  top: 80%;
  animation: lf4 0.5s linear infinite;
  animation-delay: -3s;
}

@keyframes lf {
  0% {
    left: 200%;
  }
  100% {
    left: -200%;
    opacity: 0;
  }
}

@keyframes lf2 {
  0% {
    left: 200%;
  }
  100% {
    left: -200%;
    opacity: 0;
  }
}

@keyframes lf3 {
  0% {
    left: 200%;
  }
  100% {
    left: -100%;
    opacity: 0;
  }
}

@keyframes lf4 {
  0% {
    left: 200%;
  }
  100% {
    left: -100%;
    opacity: 0;
  }
}
</style>
